import React from 'react';
import { _ } from '../../functions/translator';
import * as turf from '@turf/turf';
import { defaultAreaWidth } from '../../constants/constants';
import { getCategoryDefaultHeight } from '../../functions/finder';
import { connect } from 'react-redux';
import { fixAndToLocaleString } from '../../functions/utils'; 
// import mapboxgl from "mapbox-gl";
// import { prepareCoordinates } from '../../functions/map/mapboxDataSource';
// import { calculateAreaFromPolygon, getDistanceBetweenTwoPoints, parseCoordinatePointToMeters } from '../../functions/utils';

class MaterialsInfo extends React.Component{

    componentDidMount() {
        setTimeout(() => {
            this.handleVisibility()
        }, 1);
    }

    componentDidUpdate() {
        this.handleVisibility()
    }

    getAllFiguresVolume() {
        let figureIdsByCategory = this.groupFiguresByCategory();
        let volumen = 0;
        for (const [categoryId, figureIds] of Object.entries(figureIdsByCategory)) {
            const cardCategoryData = this.props.projectData.card_categories[categoryId];
            const figuresVolume = this.getFiguresVolume([...figureIds], cardCategoryData);
            volumen += figuresVolume;
        }
        return volumen;
    }

    groupFiguresByCategory() {
        let figureIdsByCategory = {};
        for (const cardsGroupId of this.props.selectedCardsGroupIds) {
            let cardsGroupData = this.props.projectData.cards_groups[cardsGroupId];
            if (!cardsGroupData) continue;
            let categoryId = cardsGroupData.attributes.card_category_id;
            let figureGroupId = cardsGroupData.attributes.figuregroup_id;
            let figureIdsRelated = this.props.projectData.figuregroups_map[figureGroupId];
            if (!figureIdsByCategory[categoryId]) {
                figureIdsByCategory[categoryId] = new Set();
            }
            figureIdsRelated.forEach(figureId => figureIdsByCategory[categoryId].add(figureId));
        }
        return figureIdsByCategory;
    }

    getFiguresVolume(figureIds, cardCategoryData) {
        const figureIdsWithoutVolume = [];
        let figuresVolume = 0;
        for (const figureId of figureIds) {
            const figureData = this.props.projectData.figures[figureId];
            if (!figureData) continue;
            const figureVolume = figureData.attributes.real_volume;
            const hasVolume = typeof figureVolume === 'number';
            if (hasVolume) {
                figuresVolume += figureVolume;
            } else {
                figureIdsWithoutVolume.push(figureId);
            }
        }
        if (figureIdsWithoutVolume.length) {
            const figuresArea = this.getFiguresArea(figureIdsWithoutVolume);
            let categoryHeight = 0;
            if (cardCategoryData) {
                categoryHeight = cardCategoryData.attributes.height - cardCategoryData.attributes.base_height;
            }
            if (categoryHeight === 0 && cardCategoryData) {
                categoryHeight = getCategoryDefaultHeight(cardCategoryData);
            }
            figuresVolume += figuresArea * categoryHeight;
        }
        return figuresVolume;
    }

    getFiguresArea(figureIds) {
        let area = 0;
        for (const figureId of figureIds) {
            let figureData = this.props.projectData.figures[figureId];
            let figureArea = this.getFigureArea(figureData);
            area += figureArea;
        }
        return area;
    }

    getFigureArea(figureData) {
        let coordinates = [];
        let gpsPoints = Object.values(figureData.gps_points);
        const isPoint = gpsPoints.length <= 1;
        if (isPoint) {
            return defaultAreaWidth * defaultAreaWidth;
        }
        const isLineString = gpsPoints.length <= 3; 
        if (isLineString) {
            let firstPoint = [
                gpsPoints[0].attributes.longitude, 
                gpsPoints[0].attributes.latitude
            ];
            let secondPoint = [
                gpsPoints[1].attributes.longitude, 
                gpsPoints[1].attributes.latitude
            ];
            let distanceInKm = turf.distance(firstPoint, secondPoint);
            if (gpsPoints.length === 3) {
                let thirdPoint = [
                    gpsPoints[2].attributes.longitude,
                    gpsPoints[2].attributes.latitude
                ];
                distanceInKm += turf.distance(secondPoint, thirdPoint);
            }
            return defaultAreaWidth * (distanceInKm * 1000);
        }
        for (const gpsPointData of gpsPoints) {
            coordinates.push([
                gpsPointData.attributes.longitude,
                gpsPointData.attributes.latitude
            ])
        }
        let lastIndex = coordinates.length -1;
        if (coordinates[0][0] !== coordinates[lastIndex][0] || coordinates[0][1] !== coordinates[lastIndex][1]) {
            coordinates.push(coordinates[0]);
        }
        let figurePolygon = turf.polygon([coordinates]);
        let area = turf.area(figurePolygon);
        // let reverseArea = calculateAreaFromPolygon(coordinates, this.props.projectData.attributes.coordinates.center);
        return area;
    }

    handleVisibility() {
        if (!this.component) return
        if (!this.props.popUpMenu.close && !this.component.classList.contains('show-component')) {
            this.component.classList.add('show-component')
        }
        if (this.props.popUpMenu.close && this.component.classList.contains('show-component')) {
            this.component.classList.remove('show-component')
        }
        if (this.props.popUpMenu.expanded && this.component.classList.contains('show-component')) {
            this.component.classList.remove('show-component')
        }
    }

    countTotalCost(){
        const selectedCardsGroups = this.props.selectedCardsGroups
        const projectData = this.props.projectData
        let unitsQuantities = {}
        let totalCost = 0
        if (selectedCardsGroups !== "none") {
            for (let i = 0; i < selectedCardsGroups.length; i++) {
                const cardGroupId = selectedCardsGroups[i];
                const cardGroup = projectData.cards_groups[cardGroupId];
                if (cardGroup.attributes.cost !== null) {
                    totalCost += cardGroup.attributes.cost
                }
                if (cardGroup.attributes.quantity !== null) {
                    unitsQuantities[cardGroup.attributes.unit] = (unitsQuantities[cardGroup.attributes.unit] || 0) + cardGroup.attributes.quantity;
                }
            }
        }
        return {totalCost, unitsQuantities}
    }

    render(){ 
    
        const {totalCost, unitsQuantities} = this.countTotalCost();
        const keysUnitsQuantities = Object.keys(unitsQuantities)

        
        //const volume = this.getAllFiguresVolume();
        
        // var from = turf.point([-70.64829600702421, -33.48031820413203]);
        // var to = turf.point([-70.64761748986741, -33.48027482360921]);
        // var distance = turf.distance(from, to);
        // const point1 = new mapboxgl.LngLat(-70.64829600702421, -33.48031820413203);
        // const point2 = new mapboxgl.LngLat(-70.64761748986741, -33.48027482360921);
        // const distance2 = point1.distanceTo(point2);
        // const point1InMeters = parseCoordinatePointToMeters([-70.64829600702421, -33.48031820413203], this.props.projectData.attributes.coordinates.center);
        // const point2InMeters = parseCoordinatePointToMeters([-70.64761748986741, -33.48027482360921], this.props.projectData.attributes.coordinates.center);
        // const distance3 = getDistanceBetweenTwoPoints(point1InMeters, point2InMeters);
        return (
            <div>
                <div className='materials-table-container' ref={ref => this.component = ref}>
                    {/* <h4 className='text-center'>{_('Cubicación')}</h4>
                    <table className='materials-table w-100'>
                        <tr>
                            <td className='text-center'>{ `${volume.toFixed(2)} m3` }</td>
                        </tr>
                        <tr>
                            <td className='text-center'>{ `turfjs: ${distance} km` }</td>
                        </tr>
                        <tr>
                            <td className='text-center'>{ `mapboxgl: ${distance2} m` }</td>
                        </tr>
                        <tr>
                            <td className='text-center'>{ `reverse function: ${distance3} m` }</td>
                        </tr> 
                    </table>*/}
                    <h4 className='text-center mt-2'>{_('Costo Total')}</h4>
                    <table className='materials-table w-100'>
                        <tr>
                            <td className='text-center'>{ `$ ${fixAndToLocaleString(totalCost)}` }</td>
                        </tr>
                    </table>
                    <div className={(keysUnitsQuantities.length === 0 || (keysUnitsQuantities.length === 1 && keysUnitsQuantities[0] == "null")) && 'd-none'}>
                        <h4 className='text-center mt-2'>{_('Cantidades')}</h4>
                        <table className='materials-table w-100'>
                            {keysUnitsQuantities.map((unit) => {
                                if(unit !== "null"){
                                    return <tr key={unit}>
                                            <td className='text-center'>{ `${fixAndToLocaleString(unitsQuantities[unit])} ${unit}` }</td>
                                        </tr>
                                }
                            })}
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps (state) {
    return{
        selectedCardsGroups: state.selectedCardsGroups,
        projectData: state.projectData,
    }
};

export default connect(mapStateToProps)(MaterialsInfo);
